export default class BookingRefund {
  constructor(args) {
    this.id = args.id
    this.created = args.created // timestamp
    this.updated = args.updated // timestamp
    this.status = args.status // string [currently_processing|pending|refunded|error_at_processing|paypal_processing]
    this.reason = args.reason // string [price_changed|security_issue|sold_out|technical_issue]
    this.abid = args.abid // integer
    this.amount = args.amount // float
    this.currency = args.currency // string
    this.refundTo = args.refundTo // string
    this.autoRefundAt = args.autoRefundAt // localMoment
    this.refundMethods = args.refundMethods // List<string>
  }
}
